import React, { useEffect, useRef } from "react";
import styles from "./AlertPopup.module.scss";
import { getAllClassNames } from "helpers";
import Button from "components/buttons/button/Button";
import { grad1, grad2 } from "assets/constants";

export type IAlertPopup = {
  title: string;
  subTitle?: string;
  showButton?: boolean;
  buttonText: string;
  style?: React.CSSProperties;
  onClose: () => void;
  closeButtonRef?: React.RefObject<HTMLButtonElement>;  
};

export const AlertPopup = ({
  title,
  subTitle,
  showButton,
  buttonText,
  style,
  onClose,
  closeButtonRef,
}: IAlertPopup) => {

  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (titleRef && titleRef.current) {
      titleRef.current.focus();
    }
  }, []);

  return (
    <div className={getAllClassNames(["ais-SearchBox", styles.container])}>
      <h3 className={styles.title} ref={titleRef}>{title}</h3>
      {subTitle && <p className={styles.subTitle} style={style} role="alert" tabIndex={0}>{subTitle} </p>}
      {showButton &&
        <Button
          ref={closeButtonRef}
          replaceClassName={styles.button}
          color1={grad1}
          color2={grad2}
          text={buttonText}
          onClick={() => onClose()} />
      }
    </div>
  );
};
